import { render, staticRenderFns } from "./MainMatchStatsInfo.vue?vue&type=template&id=38c67976&scoped=true&"
import script from "./MainMatchStatsInfo.vue?vue&type=script&lang=js&"
export * from "./MainMatchStatsInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainMatchStatsInfo.vue?vue&type=style&index=0&id=38c67976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c67976",
  null
  
)

export default component.exports